// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Ggck","label":"styles_label__c5sFD"};